import React from "react";
import styled from "styled-components";

const ShippingSection = styled.section`
  background: transparent;
  color: #333;
  position: relative;
  z-index: 2;
  overflow: hidden;
  top: 92%;
  left: 0;
  right: 0;

  @media (max-width: 1024px) {
    top: 95%;
  }

  @media (max-width: 768px) {
    top: 97%;
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(
        circle at 20% 20%,
        rgba(76, 175, 80, 0.05),
        transparent 25%
      ),
      radial-gradient(
        circle at 80% 80%,
        rgba(51, 93, 169, 0.05),
        transparent 25%
      );
    pointer-events: none;
  }
`;

const Title = styled.h2`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 40px;
  color: #335da9;
  text-transform: uppercase;
  letter-spacing: 2px;
  position: relative;
  padding-bottom: 15px;

  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 3px;
    background: linear-gradient(90deg, #4caf50, #45a049);
  }
`;

const CardsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    gap: 20px;
  }
`;

const Card = styled.div`
  flex: 1;
  min-width: 257.5px;
  max-width: 288.4px;
  background: #ffffff;
  padding: 30px;
  border-radius: 24px;
  border: 1px solid #f0f0f0;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    border-color: rgba(76, 175, 80, 0.3);
    box-shadow: 0 14px 41px rgba(0, 0, 0, 0.08), 0 0 18px rgba(76, 175, 80, 0.1);
  }
`;

const CardTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 15px;
  font-weight: bold;
  color: #2c3e50;
  position: relative;
  padding-bottom: 8px;

  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: #4caf50;
  }
`;

const CardText = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: #5a6c7d;
`;

const Highlight = styled.span`
  color: #4caf50;
  font-weight: 600;
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 80px;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  img {
    width: auto;
    height: 100%;
    object-fit: contain;
  }
`;

const Shipping = () => {
  const cards = [
    {
      title: "Trusted Partners",
      text: "Partnered with Delhivery, Blue Dart, DTDC, and Ekart for reliable shipping across India.",
      image: "/images/shipping images/partner.png",
    },
    {
      title: "Road, Rail & Air",
      text: "Multiple transport capabilities for reducing delivery TATs and ensuring faster reach to customers.",
      image: "/images/shipping images/air.png",
    },
    {
      title: "Best in Class Delivery",
      text: "Exceptional performance with 95% orders delivered in less than 5 days nationwide.",
      image: "/images/shipping images/fast.png",
    },
    {
      title: "Pan India COD",
      text: "Seamless COD Remittance with delivery across 27,000+ pincodes throughout India.",
      image: "/images/shipping images/cod.png",
    },
  ];

  return (
    <ShippingSection>
      <Title>SHIPPING</Title>
      <CardsContainer>
        {cards.map((card, index) => (
          <Card key={index}>
            {card.image && (
              <ImageWrapper>
                <img src={card.image} alt={card.title} />
              </ImageWrapper>
            )}
            <CardTitle>{card.title}</CardTitle>
            <CardText>
              {card.text
                .split(" ")
                .map((word, i) =>
                  word.includes("95%") || word.includes("27,000+") ? (
                    <Highlight key={i}>{word} </Highlight>
                  ) : (
                    word + " "
                  )
                )}
            </CardText>
          </Card>
        ))}
      </CardsContainer>
    </ShippingSection>
  );
};

export default Shipping;
